export default "__VITE_ASSET__C8hyu5$B__"